import React from "react";
import { Modal } from "react-bootstrap";
import { useRenewSubscriptionMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { SubscriptionIcon } from "../../../../util/Icons";

const RenewSubscriptionModal = ({ showRenewSubscriptionModal, onHide, details, tableRef }) => {
    const [
        renewSubscription, // This is the mutation trigger
        {
            isLoading: isRenewing,
        }, // This is the destructured mutation result
    ] = useRenewSubscriptionMutation()

    /* Renew Subscription */
    const renew = () => {
        renewSubscription({
            userId: details?.userId,
            subId: details?.id,
            meta: details,
        })
            .unwrap()
            .then(() => {
                cogoToast.success("Created 'Renew Subscription' action successfully")
                tableRef.current.refresh()
                onHide()
            })
    }

    return (
        <Modal
            show={showRenewSubscriptionModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isRenewing ? "static" : true}
            keyboard={!isRenewing}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SubscriptionIcon />
                    </span>
                    Renew Subscription
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>

            <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                <p>Are you sure you want to renew <strong>{details?.product}</strong> subscription for <strong>{details?.username}</strong></p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    onClick={onHide}
                    disabled={isRenewing}
                    className="btn btn-light btn-elevate px-4"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    disabled={isRenewing}
                    className="btn btn-primary btn-elevate px-4 ml-4"
                    onClick={renew}
                >
                    Renew Subscription
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default RenewSubscriptionModal;
